var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "margin-left:" + _vm.level * 35 + "px;" },
    [
      _c("v-autocomplete", {
        staticStyle: { width: "300px", display: "flex" },
        attrs: {
          label: _vm.$t("settings.workflow.acceptors"),
          items: _vm.users,
          "item-value": "id",
          "item-text": "fullName",
          multiple: "",
          "small-chips": "",
          "deletable-chips": ""
        },
        model: {
          value: _vm.contextUserIds,
          callback: function($$v) {
            _vm.contextUserIds = $$v
          },
          expression: "contextUserIds"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }